<template lang="html">
  <section id="appContainer">
    <el-container class="needLoginContainer" v-if="$route.meta.isAside" >
      <el-aside class="asideContainer" width="auto">
        <Menu ref="menuRef"></Menu>
      </el-aside>
      <el-container class="HMContainer">
        <el-header class="headerContainer">
          <Header ref="headeRef"></Header>
        </el-header>
        <el-main class="mainContainer">
          <section class="mainBox">
            <router-view  class="mainCont"/>
          </section>
        </el-main>
      </el-container>
    </el-container>
    <section v-else class="nonLoginContainer">
      <router-view  />
    </section>
  </section>
</template>
<script>
import API from '@/api/api';
import Header from '@/components/header.vue';
import Menu from '@/components/menu.vue';

export default {
  components:{
    Header,
    Menu
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    }
  },

  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  created() {
    // console.log(this.$config.analysisToken())

  },
  mounted() {
    this.handleRouteChange()
  },
  watch: {
    '$route':{
      // immediate:true,
      handler(now,old){
        this.handleRouteChange(now,old)
      },
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      })
    },
    handleRouteChange(){
      let {meta} =  this.$route;
      console.log(this.$route,'this.$route')
      if(meta.isLogin){
      //需要登录
        let token = this.$config.getStorageInfo('token')
        if(!token){
          this.$router.push('/login')
        }
      }





    },

  }
}

</script>

<style scoped type="css/text">
@import "config/css/root.css";
#appContainer {
  font-size: 0px;
  height: 100%;
  box-sizing: border-box;

}

.needLoginContainer{
  height: 100%;
  min-width: 1280px;
  background-color: #eeeeee;
}
.asideContainer{
  height: 100%;
  /*background-color: antiquewhite;*/
}
.HMContainer{}
.headerContainer{
  /*background-color: #ffffff;*/
  box-sizing: border-box;
  padding: 0;
  background-color: white;
}
.mainContainer{
  box-sizing: border-box;
  padding: 15px 0px 15px 15px;
  background-color: #eeeeee;
}
.mainBox{
  height: 100%;
  overflow: auto;
  padding-right: 15px;
  box-sizing: border-box;
}
.mainCont{
  background-color: white !important;
  padding: 15px 10px;
  box-sizing: border-box;
  min-height: 100%;
}
.nonLoginContainer{
  height: 100%;
  box-sizing: border-box;
  /*background-color: aliceblue;*/
}



</style>
